import mittfn from 'mitt'
const mitt = mittfn()
export default mitt
export { mitt }